import template from './trip-traveller-allocation.html';

const DIRECTIVE_NAME = TripTravellerAllocation.DIRECTIVE_NAME = 'ktTripTravellerAllocation';
export default function TripTravellerAllocation() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripTravellerAllocationController,
        controllerAs: '$ctrl',
        scope: {
            isHold: `=?${DIRECTIVE_NAME}IsHold`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripTravellerAllocationController(
    seatmapAvailabilityService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isSeatmapAvailableForFlightRecommendation: seatmapAvailabilityService.isSeatmapAvailableForFlightRecommendation,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-component.js